import { render, staticRenderFns } from "./Studios.vue?vue&type=template&id=69e7de74&scoped=true&"
import script from "./Studios.vue?vue&type=script&lang=js&"
export * from "./Studios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e7de74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69e7de74')) {
      api.createRecord('69e7de74', component.options)
    } else {
      api.reload('69e7de74', component.options)
    }
    module.hot.accept("./Studios.vue?vue&type=template&id=69e7de74&scoped=true&", function () {
      api.rerender('69e7de74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/studios/Studios.vue"
export default component.exports